import React, { useState, useContext, useEffect } from "react";
import { UserContext, BaseUrl } from "../../App.js";
import handleToolTip from "../Utils/tooltip.js";
import Form from "../../UI/Form/Form";

function ChangeUserName(props) {
  const [user] = useContext(UserContext);
  const [oldName, setOldName] = useState("");
  const [newName, setNewName] = useState("");
  const [state, setState] = useState({ message: "" });
  const { logOutCallback } = props;

  const handleSubmit = async (event) => {
    event.preventDefault();

    const result = await (
      await fetch(`${BaseUrl}/user/name`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.accesstoken}`,
        },
        body: JSON.stringify({
          old_name: oldName,
          new_name: newName,
        }),
      })
    ).json();

    if (result.status === "success") logOutCallback();
    else setState({ message: result.error });
  };

  const handleInput = (event) => {
    if (event.target.name === "old name") {
      setOldName(event.target.value.toUpperCase());
    } else setNewName(event.target.value.toUpperCase());
  };

  handleToolTip(
    "change-user-name-tool-tip",
    "change-user-name-input",
    "change-user-name-form"
  );

  useEffect(() => {
    if (document.getElementById("change-user-name-tool-tip")) {
      const setToolTip = document.getElementById("change-user-name-tool-tip");
      if (state.message !== "") setToolTip.textContent = state.message;

      setTimeout(() => {
        setToolTip.textContent = "";
      }, 3000);
    }
  }, [state.message]);

  return (
    <Form
      firstInputId="change-user-name-input"
      firstInputType="text/number"
      firstInputLabel="old name"
      firstInputPlaceHolder="Old User Name"
      firstInputValue={oldName}
      secondInputPlaceHolder="New User Name"
      secondInputType="text/number"
      secondInputLabel="new name"
      secondInputValue={newName}
      buttonType="submit"
      formTitle="Change User Name"
      onOldNameInputChange={handleInput}
      onNewNameInputChange={handleInput}
      handleSubmit={handleSubmit}
    />
  );
}
export default ChangeUserName;
